"use client"
import React from 'react';
import './preloader.css';

export default function Preloader() {
  return (
    <>
    <div className="preloader">
        <div className="bg"></div>
        <div className="raven">
            <span></span>
        </div>
    </div>
    </>
  )
}